// ═══════════════════════════════════════════════════════════════
// Shared primitives for resolving a validate RuleAttachment's sources.
//
// Both the runtime collector (rule-runtime content-validate.ts →
// iterAuthoredFieldValidates) and the F-083 "can never fire" predicate
// (validate-rule-cannot-fire.ts) must agree on:
//   • which validate sources a rule fans out to (validate actions when
//     present, else the legacy rule.config fallback), and
//   • which editor validationTypes are evaluated OUTSIDE the pure
//     field-validate path (batch-gate server path / webhook dispatch).
// Single-sourced here so the predicate cannot drift from the runtime it
// predicts.
// ═══════════════════════════════════════════════════════════════
/** Editor validationType values that are NOT client-evaluable pattern checks —
 *  server-data rules (uniqueness / historicalRange) evaluated by the batch-gate
 *  server path, OR webhook checks. The pure field-validate collector skips
 *  them; the cannot-fire predicate treats them as firing (server path). */
export const SERVER_EVALUATED_VALIDATE_TYPES = new Set([
    'uniqueness',
    'historicalRange',
    'webhook',
    'webhook_validate',
]);
/**
 * The actions-vs-legacy-`config` fan-out: a rule's `validate` actions when
 * any exist, else a single legacy source from `rule.config` (carrying the
 * rule-level severity, no message — message-home priority is applied by the
 * emit loop). The target field of a source is `targetField ?? rule.fieldRef`,
 * resolved by the caller.
 */
export function validateRuleSources(rule) {
    const validateActions = (rule.actions ?? []).filter((a) => a.type === 'validate');
    return validateActions.length > 0
        ? validateActions.map((a) => ({
            config: a.config ?? {},
            ...(a.targetField !== undefined ? { targetField: a.targetField } : {}),
            ...(a.message !== undefined ? { message: a.message } : {}),
            ...(a.severity !== undefined ? { severity: a.severity } : {}),
        }))
        : [{ config: rule.config ?? {}, severity: rule.severity }];
}
//# sourceMappingURL=validate-rule-sources.js.map